import React, { useEffect, useState } from 'react';
import { Box, Heading, Text, Table, Thead, Tbody, Tr, Th, Td, Flex, Spinner, Icon, useColorModeValue } from '@chakra-ui/react';
import { FaTrophy, FaMedal } from 'react-icons/fa';
import axios from 'axios';
import { useSelector } from 'react-redux';

const QuizLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";

  const cardBg = useColorModeValue("white", "var(--bg-surface, #161428)");
  const textDark = useColorModeValue("#0a2628", "var(--text-main, #EDE9FF)");

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/standalone-quiz/leaderboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setLeaderboard(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Flex justify="center" p={10}><Spinner /></Flex>;

  return (
    <Box p={6} bg={cardBg} borderRadius="3xl" boxShadow="sm">
      <Flex align="center" gap={3} mb={6}>
        <Box p={3} bg="yellow.50" borderRadius="2xl" color="yellow.500">
          <FaTrophy size={24} />
        </Box>
        <Box>
          <Heading size="md" fontWeight="900" color={textDark}>LNA Leaderboard</Heading>
          <Text fontSize="sm" color="gray.400" fontWeight="600">Top performers in standalone quizzes</Text>
        </Box>
      </Flex>

      {leaderboard.length === 0 ? (
        <Text color="gray.400">No data available yet. Be the first to take a quiz!</Text>
      ) : (
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>Rank</Th>
              <Th>Employee</Th>
              <Th>Department</Th>
              <Th isNumeric>Total Score</Th>
              <Th isNumeric>Quizzes Taken</Th>
            </Tr>
          </Thead>
          <Tbody>
            {leaderboard.map((user, idx) => (
              <Tr key={user.userId}>
                <Td>
                  {idx === 0 && <Icon as={FaMedal} color="yellow.400" mr={2} />}
                  {idx === 1 && <Icon as={FaMedal} color="gray.400" mr={2} />}
                  {idx === 2 && <Icon as={FaMedal} color="orange.400" mr={2} />}
                  {idx + 1}
                </Td>
                <Td fontWeight="bold">{user.name}</Td>
                <Td>{user.department}</Td>
                <Td isNumeric fontWeight="bold" color="purple.400">{user.totalScore}</Td>
                <Td isNumeric>{user.quizzesTaken}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default QuizLeaderboard;
